import axios from '@/libs/api.request'

export const createQuoteGroup = (type, data) => {
  return axios.request({
    url: `quotes/group/${type}`,
    method: 'post',
    data
  })
}

export const updateQuoteGroup = (id, data) => {
  return axios.request({
    url: `quotes/group/${id}`,
    method: 'put',
    data
  })
}

export const getQuoteGroup = (id) => {
  return axios.request({
    url: `quotes/group/${id}`,
    method: 'get'
  })
}

export const getQuoteGroupList = (params) => {
  return axios.request({
    url: `quotes/group/list`,
    method: 'get',
    params: params
  })
}

export const deleteQuoteGroup = (id) => {
  return axios.request({
    url: `quotes/group/${id}`,
    method: 'delete'
  })
}

export const createQuoteFromGroupQuote = (id, data) => {
  return axios.request({
    url: `quotes/group/${id}/create-quote`,
    method: 'post',
    data
  })
}

export const getQuotesFromQuoteGroup = (id) => {
  return axios.request({
    url: `quotes/group/${id}/quotes`,
    method: 'get'
  })
}
